<template>
  <div class="yxtbiz-label-audit">
    <div class="standard-size-16 color-gray-10">
      <yxtf-row type="flex" class="mv24 font-normal font-size-14">
        <yxtf-col :span="12" class="mh2 flex">
          <span class="color-gray-7 nowrap"
            >{{ $t('pc_biz_sp_employee' /** 员工 */) }}：</span
          >
          <yxtf-tooltip :open-filter="true" placement="top">
            <div slot="content">
              <yxtbiz-user-name :name="detail.fullname" />
              <span>{{ '（' + detail.username + '）' }}</span>
            </div>
            <div class="yxtbiz-label-audit_ellipsis">
              <yxtbiz-user-name :name="detail.fullname || ''" />
              <span v-show="detail.username">{{
                '（' + detail.username + '）'
              }}</span>
            </div>
          </yxtf-tooltip>
        </yxtf-col>
        <yxtf-col :span="12" class="mh2 flex">
          <span class="color-gray-7 nowrap"
            >{{ $t('pc_biz_sp_label' /**  标签 */) }}：</span
          >
          <yxtf-tooltip
            :open-filter="true"
            :content="detail.labelName"
            placement="top"
          >
            <div class="yxtbiz-label-audit_ellipsis">
              {{ detail.labelName || '--' }}
            </div>
          </yxtf-tooltip>
        </yxtf-col>
      </yxtf-row>
      <yxtf-row type="flex" class="mv24 font-normal font-size-14">
        <yxtf-col :span="24" class="mh2 flex">
          <span class="color-gray-7 nowrap"
            >{{ $t('pc_biz_sp_addLabelValue' /**新增标签值 */) }}：</span
          >
          <yxtf-tooltip
            :open-filter="true"
            :content="detail.addLabelValue"
            placement="top"
          >
            <div class="yxtbiz-label-audit_ellipsis">
              {{ detail.addLabelValue || '--' }}
            </div>
          </yxtf-tooltip>
        </yxtf-col>
      </yxtf-row>
      <yxtf-row type="flex" class="mv24 font-normal font-size-14">
        <yxtf-col :span="24" class="mh2 flex">
          <span class="color-gray-7 nowrap"
            >{{ $t('pc_biz_sp_removeLabelValue' /**移除标签值 */) }}：</span
          >
          <yxtf-tooltip
            :open-filter="true"
            :content="detail.removeLabelValue"
            placement="top"
          >
            <div class="yxtbiz-label-audit_ellipsis">
              {{ detail.removeLabelValue || '--' }}
            </div>
          </yxtf-tooltip>
        </yxtf-col>
      </yxtf-row>
    </div>
  </div>
</template>

<script>
import { getDeatilApi } from './service';
export default {
  name: 'YxtbizLabelAudit',
  name_zh: '员工标签审核',
  eventList: [],
  slots: [],
  props: {
    id: {
      type: String,
      default: '',
      desc: '审核详情ID',
      setter: 'StringSetter'
    }
  },
  data() {
    return {
      detail: {}
    };
  },
  created() {
    this.getLabelDeatil();
  },
  methods: {
    getLabelDeatil() {
      getDeatilApi(this.id).then(res => {
        const detail = res || {};
        detail.addLabelValue = detail.addList ? detail.addList.join(',') : '--';
        detail.removeLabelValue = detail.removeList
          ? detail.removeList.join(',')
          : '--';
        this.detail = detail;
      });
    }
  }
};
</script>
